import { useField, useFormikContext } from 'formik';
import React from 'react';

import styled from '@emotion/styled';

import ActiveRadioButtonCircle from '../Icons/ActiveRadioButtonCircle';
import InActiveRadioButtonCircle from '../Icons/InActiveRadioButtonCircle';
import { FieldErrorInfo } from './FormField';

interface CustomStackedPlainRadioFieldGroupProps {
  children: React.ReactNode;
  name: string;
  label?: string;
  className?: string;
}

export const CustomStackedPlainRadioFieldGroup: React.FC<
  CustomStackedPlainRadioFieldGroupProps
> = ({ children, name, label, className }) => {
  const { errors, touched } = useFormikContext<any>();

  return (
    <RadioGroupWrapper>
      {label && <InputLabel className={className ?? ''}>{label}</InputLabel>}
      <RadioGroup>
        {React.Children.map(children, (child: any) => {
          return React.cloneElement(child, {
            ...child.props,
          });
          // }
        })}
      </RadioGroup>

      {errors[name] && touched[name] ? (
        <CustomFieldErrorInfo>
          {(errors as any)[name].capitalize()}
        </CustomFieldErrorInfo>
      ) : null}
    </RadioGroupWrapper>
  );
};

export interface CustomStackedPlainRadioProps {
  label?: any;
  id?: string;
  name: string;
  children?: any;
  className?: string;
  value?: string;
}

export const CustomStackedPlainRadio: React.FC<
  CustomStackedPlainRadioProps
> = ({ children, className, ...props }) => {
  const [field] = useField({ ...props, type: 'radio' });

  return (
    <RadioWrapper className={className}>
      <label>
        <input type='radio' {...field} {...props} />
        <RadioItemDiv className={className}>
          <RadioItemActiveIcon className='active'>
            <ActiveRadioButtonCircle />
          </RadioItemActiveIcon>
          <RadioItemInactiveIcon className='inactive'>
            <InActiveRadioButtonCircle />
          </RadioItemInactiveIcon>

          {children}
        </RadioItemDiv>
      </label>
    </RadioWrapper>
  );
};

const RadioItemDiv = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  border-radius: 6px;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  height: 40px;

  &.hug {
    height: 20px;
  }
`;

export const InputLabel = styled.label`
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  /* margin-bottom: 10px; */
  color: black;
  user-select: none;

  &.large {
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
  }
`;
const RadioItemActiveIcon = styled.div`
  display: none;
`;

const RadioItemInactiveIcon = styled.div``;

const RadioWrapper = styled.div`
  & > label {
    width: 100%;
    display: grid;
    /* border: 1px solid blue; */
    padding: 0px;

    & > * {
      grid-column: 1;
      grid-row: 1;
    }

    & > * {
      font-weight: 500;
      font-size: 14px;
      line-height: 14px;
      color: #6e7079;
    }
  }

  & > label input[type='radio'] {
    visibility: hidden;
  }

  & > label input[type='radio']:checked ~ div > .active {
    display: block;
  }

  & > label input[type='radio']:checked ~ div > .inactive {
    display: none;
  }

  & > * {
    cursor: pointer;
  }
`;

const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;
  gap: 16px;
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;

  & > * {
  }
`;

const CustomFieldErrorInfo = styled(FieldErrorInfo)`
  margin-top: 0px;
`;
